import { render, staticRenderFns } from "./payment-failed.vue?vue&type=template&id=102475f5&scoped=true&"
import script from "./payment-failed.vue?vue&type=script&lang=js&"
export * from "./payment-failed.vue?vue&type=script&lang=js&"
import style0 from "./payment-failed.vue?vue&type=style&index=0&id=102475f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102475f5",
  null
  
)

export default component.exports